export default "__VITE_ASSET__WIiI0qB1__"